/**
 * Action: Reset all reduces except loginReducer
 */
export const RESET_ALL_REDUCERS = 'RESET_ALL_REDUCERS';
